import { FlaskConical } from 'lucide-react';

import { DropdownMenuItem } from '@/components/ui/dropdown-menu';
import type { TestDataEntityType } from '@/services/platform/test-data';
import { useMarkAsTest } from './useMarkAsTest';

/**
 * Drop into any row/detail DropdownMenuContent to toggle an entity's
 * test flag in-context. Pass `marked` so the item reflects current state
 * (Mark vs Unmark). Renders nothing when the tenant lacks the
 * test-data-tools flag. Mounts lazily (Radix only renders menu content
 * when open), so the mutation hook isn't instantiated per row.
 */
export function MarkAsTestMenuItem({
  entityType,
  entityId,
  marked = false,
}: {
  entityType: TestDataEntityType;
  entityId: string;
  marked?: boolean;
}) {
  const { enabled, mark, unmark } = useMarkAsTest(entityType);
  if (!enabled) return null;
  return (
    <DropdownMenuItem onClick={() => (marked ? unmark(entityId) : mark(entityId))}>
      <FlaskConical className="h-3.5 w-3.5" />
      {marked ? 'Unmark test' : 'Mark as test'}
    </DropdownMenuItem>
  );
}
